import WrapperProvider from "@providers/WrapperProvider";
import RoomsContainer from "@containers/RoomsContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import _ from "lodash";
import RoomService from "@services/RoomService";
import Layout from "@components/Layout";
import { getServer } from "@translations/next";
import StrapiService from "@services/StrapiService";
import FooterService from "@services/FooterService";

export default function View(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <RoomsContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "hotel10-room-page");
  const resRoomPage = await StrapiService.find({
    populate: "deep",
    locale,
  });
  StrapiService.set("id", "hotel10-stay-connected");
  const resPage = await StrapiService.find({
    populate: "deep",
    locale,
  });
  // const resCategory = await StoryCategoryService.find({
  //   populate: "deep",
  //   locale,
  // });
  const res = await RoomService.find({
    filters: {
      hotel: {
        slug: {
          $eq: "amanaki-thao-dien",
        },
      },
    },
    populate: "deep",
    locale,
    page: 1,
    pageSize: 200,
  });
  const footerData = await FooterService.fetchByHotel("amanaki-thao-dien", locale);
  return {
    hotel: "amanaki-thao-dien",
    pageData: {
      ..._.get(resRoomPage, "data", {}),
      stayConnected: _.get(resPage, "data", {}),
    },
    rooms: _.get(res, "data", []),
    footerData,
    // categories: _.get(resCategory, "data", {}),
  };
});
